<template>
  <v-container grid-list-xl pa-0>
    <v-row class="ml-3 mt-n9">
      <div class='headline'>Подтверждение платежа</div>
    </v-row>
    <template v-if="!isChecked">
      <v-card class="mx-auto d-flex align-content-center flex-wrap center-card" max-width="800" height="300">
        <v-row class="mt-n12">
          <v-col class="col-12" align-self="center">
            <div class="headline" align="center">Проверка статуса оплаты</div>
          </v-col>
          <v-col class="col-12 pa-6">
            <v-progress-linear color="light-blue" height="5" striped indeterminate>
            </v-progress-linear>
          </v-col>
        </v-row>
      </v-card>
    </template>
    <template v-else>
      <v-card class="mx-auto mt-10 pa-9" max-width="600">
        <template v-if="isPaymentOk">
          <font-awesome-icon class="result-icon" :style="{ color: '#009688' }" :icon="['far', 'check-circle']" />
          <div class="headline" align="center">Платёж выполнен</div>
        </template>
        <template v-else>
          <font-awesome-icon class="result-icon" :style="{ color: '#C62828' }" :icon="['far', 'times-circle']" />
          <div class="headline" align="center">Платёж не прошёл</div>
          <div class="subtitle-1 mt-4" align="center">{{ paymentInfo['status'] }}</div>
        </template>
        <v-data-table :items="paymentData" class="elevation-0 mt-6" hide-default-footer hide-default-header :loading="searchDialog" loading-text="Данные загружаются...">
          <template v-slot:item="props">
            <tr>
              <td>
                {{ props.item.name }}
              </td>
              <td class="text-xs-left">
                {{ props.item.value }} {{ props.item.suffix }}
              </td>
            </tr>
          </template>
          <template v-slot:no-data>
            <v-alert :value="true">
              Нет данных
            </v-alert>
          </template>
        </v-data-table>
      </v-card>
    </template>
  </v-container>
</template>
<script>
export default {
  name: 'PaymentReturnPage',

  props: {
    transId: {
      type: String,
      default: null
    }
  },

  data: () => ({
    isPaymentOk: false,
    isChecked: false,
    visibleFields: [
      {
        name: 'Лицевой счёт',
        code: 'account_number'
      },
      {
        name: 'Услуга',
        code: 'service'
      },
      {
        name: 'Сумма',
        code: 'amount'
      },
      {
        name: 'E-mail',
        code: 'e_mail'
      },
      {
        name: 'Номер транзакции',
        code: 'transaction_id'
      }
    ],
    paymentInfo: { 'e_mail': '' },
    searchDialog: false
  }),
  computed: {
    paymentData: function() {
      if (!this.paymentInfo) {
        return []
      }

      const vm = this

      return this.visibleFields
        .map((field) => ({
          name: field.name,
          value: vm.paymentInfo[field.code],
          code: field.code
        }))
    }
  },
  created: async function() {
    this.searchDialog = true
    try {
      let urlParams = new URLSearchParams(window.location.search);
      this.transId = urlParams.get('mdOrder');
      const resp = await this.$api.Account.getPaymentData(this.transId)
      this.paymentInfo = resp.data
      this.isChecked = !resp.data['is_processing']
      this.isPaymentOk = resp.data['is_payment_ok']
      this.searchDialog = false
      if (!this.isChecked) {
        let self = this
        let timerId = setInterval(
          async function() {
            const resp = await self.$api.Account.getPaymentData(self.transId)
            self.paymentInfo = resp.data
            self.isChecked = !resp.data['is_processing']
            if (self.isChecked) clearInterval(timerId)
          }, 300000)
      }
      //this.isChecked = true
    } catch (e) {
      this.searchDialog = false
      console.log(e)
      let error = 'Во время выполнения запроса произошла ошибка'
      await this.$store.dispatch('notification/setSystemNotification', { message: error, type: 'error' })
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.result-icon {
  display: block;
  margin-left: auto;
  margin-right: auto;
  font-size: 60pt;
  height: 100px;
  color: black;
}

.center-card {
  margin-top: 10%;
}
</style>